<header>
    <!-- <img src="./assets/login-header.jpg" style="width: 100%;"> -->
    <div class="row">
        <div class="col-md-12" style="padding: 0;" style="background-image: url('./../../../assets/bg.png');background-repeat: no-repeat;background-size: cover;">
            <img src="./../../../assets/Logo2.png" alt="Dental Council of India" title="Dental Council of India">
            <!-- <a href="https://rashtragaan.in/">         
                <img src="./../../../assets/Logo75.png" class="tabView" alt="Dental Council of India" title="Dental Council of India">
            </a>
            <img src="./../../../assets/logoembdig.png" alt="Dental Council of India" title="Dental Council of India"> -->
       <img src="./../../../assets/Digital_India_logo.png" alt="Dental Council of India" title="Dental Council of India"
            style="position: absolute; top: 10px; right: 20px; height: 70px;">
        </div>
    </div>
    <div class="container-fluid mt-4">
        <div class="row">
            <div class="col-md-6">
                <h5 class="headingValue">Payment </h5>
            </div>
            <div class="col-md-6 text-right">
                <!-- <button class="globalBtn clearBtn" routerLink="../login" (click)="back()">Back</button> -->
                <button class="globalBtn clearBtn" (click)="back()">Back</button>
            </div>
        </div>
        <hr>
    </div>
</header>

<div class="container h-100" style="background: #eee;padding: 15px;">
    <div class="row">
        <div class="col-md-12 p-0">
            <div class="card">
                <form id="guruId" [formGroup]="paymentForm" role="form" autocomplete="off"
                    class="has-validation-callback">

                    <div class="bt-tab-content-main">

                        <div class="tab-content" style="margin-top: 15px">
                            <div class="row">
                                <div class="col-md-4">
                                  <label>Name <span class="aseticcolor">*</span></label>
                                  <input type="text" placeholder="Name" class="form-control" formControlName="name"
                                      maxlength="90" (keypress)="keyPressName($event)" [(ngModel)]="paymentObj.name">
                                  <div *ngIf="submitted && paymentForm.controls['name'].hasError('required')"
                                      class="failed-validation" class="errorColor">
                                      Name Required
                                  </div>
                                </div>
                              
                                <div class="col-md-4">
                                  <label>Phone No <span class="aseticcolor">*</span></label>
                                  <input type="text" placeholder="Phone No" class="form-control" formControlName="phoneNo"
                                      maxlength="10" (keypress)="keyPressNumberAndplus($event)"  [(ngModel)]="paymentObj.phoneNo">
                                  <div *ngIf="submitted && paymentForm.controls['phoneNo'].hasError('required')"
                                      class="failed-validation" class="errorColor">
                                      Phone No Required
                                  </div>
                                </div>
                              
                                  <div class="col-md-4">
                                    <label>Email ID <span class="aseticcolor">*</span></label>
                                    <input type="text" placeholder="Email ID" class="form-control" formControlName="emailId"
                                        maxlength="100"  [(ngModel)]="paymentObj.emailId">
                                        <div *ngIf="submitted && paymentForm.controls['emailId'].hasError('required')"
                                      class="failed-validation" class="errorColor">
                                      Email Id Required
                                  </div>
                                  </div>
                                  
                              </div>
                              <br>
                              
                              <div class="row">
                                  <div class="col-md-4">
                                    <label>Product <span class="aseticcolor">*</span> </label>
                                    <!-- <input type="text" placeholder="Product" class="form-control" formControlName="product"
                                        maxlength="100"  [(ngModel)]="paymentObj.product"> -->
                                        <select formControlName="product" class="form-control"  placeholder="Select" [(ngModel)]="paymentObj.product">
                                              <option value="" disabled selected style="color:orange">Select</option>
                                              <option *ngFor="let products of productOption" [value]="products">
                                                  {{ products }}
                                              </option>
                                          </select>
                                      
                                        <div *ngIf="submitted && paymentForm.controls['product'].hasError('required')"
                                          class="failed-validation" class="errorColor">
                                          Product Required
                                      </div>
                                  </div>
                                  <div class="col-md-4">
                                    <label>Amount <span class="aseticcolor">*</span></label>
                                    <input type="text" placeholder="Amount" class="form-control" formControlName="amount"
                                        maxlength="10"  (keypress)="keyPressNumberAndplus($event)"  [(ngModel)]="paymentObj.amount">
                                  
                                        <div *ngIf="submitted && paymentForm.controls['amount'].hasError('required')"
                                        class="failed-validation" class="errorColor">
                                        Amount Required
                                    </div>
                                  </div>
                                 
                                </div>
                              <br>

                        </div>
                        <div class="clearfix"></div>
                    </div>
                </form>

                    <div class="row">
                        <div class="col-md-3" style="margin-top:30px; margin-left: 40%;">
                            <button class="btn btn-primary acceptBtn"  (click)="initiatePayment()" >Initiate Payment</button>&nbsp;&nbsp;
                            &nbsp;<button class="btn btn-danger clearBtn" (click)="reset()" >Reset</button>&nbsp;
                        </div>
                    </div>
                        <div *ngIf="initiatePaymentReq">
                            <div class="row" >
                                <div class="col-md-4">
                                    <h5 class="headingValue">Payment Request URL</h5>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                  <label>{{initiatePaymentReqText}} </label>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="initiatePaymentEncyReq">
                            <div class="row" >
                                <div class="col-md-4">
                                    <h5 class="headingValue">Encrypted Payment Request URL</h5>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                  <label>{{initiatePaymentEncyReqText}} </label>
                                </div>
                            </div>
                        </div>

            </div>
        </div>
    </div>
</div>